module.exports = __webpack_public_path__ + "static/media/ic_sos.1299db07.svg";